export default __webpack_public_path__ + "static/media/cookingoils-only.4d872c56.png";